/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import { Drawer,IModuleProps } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';
import { ICittaCollapsibleRecommendationsData } from './citta-collapsible-recommendations.data';
import { ICittaCollapsibleRecommendationsProps } from './citta-collapsible-recommendations.props.autogenerated';

export interface ICittaCollapsibleRecommendationsViewProps extends ICittaCollapsibleRecommendationsProps<ICittaCollapsibleRecommendationsData> {
    cittaCollapsibleRecommendations:React.ReactNode;
    collapsibleRecommendationContainer:IModuleProps;
}

/**
 *
 * CittaCollapsibleRecommendations component
 * @extends {React.PureComponent<ICittaCollapsibleRecommendationsProps<ICittaCollapsibleRecommendationsData>>}
 */
class CittaCollapsibleRecommendations extends React.PureComponent<ICittaCollapsibleRecommendationsProps<ICittaCollapsibleRecommendationsData>> {
    public constructor(props: ICittaCollapsibleRecommendationsProps<ICittaCollapsibleRecommendationsData>) {
        super(props);
    }
    public render(): JSX.Element | null {
        const desktopClass = this.props.config.darkArrowDesktop ? 'dark-desktop' : '';
        const mobileClass = this.props.config.darkArrowMobile ? 'dark-mobile' : '';
        const displayPreview = this.props.config.displayPreviewText ? 'display-preview' : '';
        const wrapperClass = `citta-collapsible-recommendations ${desktopClass} ${mobileClass} ${displayPreview}`;
        const viewProps = {
            collapsibleRecommendationContainer: {
                moduleProps: this.props,
                className: classnames(wrapperClass)
            },
            ...this.props,
            cittaCollapsibleRecommendations: this. _cittaCollapsibleRecommendations()

        };
        return this.props.renderView(viewProps);
    }
    private _cittaCollapsibleRecommendations(): React.ReactNode {
        const { slots } = this.props;
        const recommendations = slots && slots.recommendations && slots.recommendations.length ? slots.recommendations : undefined;
        return(
            <div>
            {recommendations &&
                <Drawer
                    collapseProps={
                        {
                            timeout: 1000
                        }
                    }
                    toggleButtonText='click to preview'
                    openGlyph='fas fa-angle-up'
                    closeGlyph='fas fa-angle-down'
                    glyphPlacement='end'
                    toggleButtonProps={
                        {
                            color: 'light',
                            tag: 'button',
                            'aria-label': 'click to preview'
                        }
                    }
                >
                    <div className='citta-collapsible-recommendations-content'>
                        {recommendations}
                    </div>
                </Drawer>
            }
            </div>
        );
    }
}

export default CittaCollapsibleRecommendations;
